import { Component, Inject } from '@angular/core';
import { PreviouslyPurchasedProductListConfigService } from '../../services/previously-purchased-product-list-config/previously-purchased-product-list-config.service';
import { ProductListV2Component } from '../product-list-v2/product-list-v2.component';
import { ActivatedRoute } from '@angular/router';
import { AssortmentService } from '../../services/assortment.service';
import { NavigationConfig } from '../../models/navigation-config';
import { CurrentAssortmentService } from '../../services/base-view-config/base-view-config.service';

@Component({
  selector: 'lib-previously-purchased-product-list',
  templateUrl: './previously-purchased-product-list.component.html',
  styleUrl: './previously-purchased-product-list.component.scss',
  standalone: false
})
export class PreviouslyPurchasedProductListComponent extends ProductListV2Component {
  constructor(
    public productListConfigService: PreviouslyPurchasedProductListConfigService,
    public route: ActivatedRoute,
    protected assortmentService: AssortmentService,
    public currentAssortmentSerivce: CurrentAssortmentService,
    @Inject('environment')
    protected environment: NavigationConfig
  ) {
    super(
      productListConfigService,
      route,
      assortmentService,
      currentAssortmentSerivce,
      environment
    );
  }
}
